export enum ModuleGraphType {
	BAR_STACKED = 'BAR_STACKED', // BAR_STACKED
	POLAR_AREA = 'POLAR_AREA', // POLAR_AREA
	DOUGHNUT = 'DOUGHNUT', // DOUGHNUT
	RADAR = 'RADAR', // RADAR
	LINE = 'LINE', // LINE
	PIE = 'PIE', // PIE
	BAR = 'BAR', // BAR
}
